import { render } from "./InvoicesView.vue?vue&type=template&id=943fcfaa"
import script from "./InvoicesView.vue?vue&type=script&lang=js"
export * from "./InvoicesView.vue?vue&type=script&lang=js"

import "./InvoicesView.vue?vue&type=style&index=0&id=943fcfaa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__